













































import { Alert, NoticeClass } from '@kasasa/fbase-components/lib';
import { SavedDailyLoadFilter } from '@/api/dashboard/SavedDailyLoadFilter';
import DailyLoadDeleteFilterDialog from '@/components/dailyload/dailyloaddeletefilterdialog.vue';
import { SavedDailyLoadFilterResource } from '@/api/dashboard/SavedDailyLoadFilterResource';
import Vue from 'vue';
import {
  Component, Prop, Watch, Inject,
} from 'vue-property-decorator';

@Component({
  components: {
    DailyLoadDeleteFilterDialog,
  },
})
export default class DailyLoadCreateFilterDialog extends Vue {
  @Prop() value!: SavedDailyLoadFilter | null;

  @Prop({ default: false }) loading!:boolean;

  @Prop({ default: () => [] }) filters!:SavedDailyLoadFilter[];

 	@Inject('SavedDailyLoadFilterResource')
	savedDailyLoadFilterResource!: SavedDailyLoadFilterResource;

  selectedFilter: SavedDailyLoadFilter | null = null;

  deleteFilter: SavedDailyLoadFilter | null = null;

  showDeleteDialog: boolean = false;

  deleting: boolean = false;

  mounted() {
    this.onInitialFilterChanged();
  }

  @Watch('value', { deep: true })
  onInitialFilterChanged() {
    this.selectedFilter = this.value;
  }

  @Watch('selectedFilter')
  onSelectedItem() {
    this.$emit('input', this.selectedFilter);
  }

  onClickFilterDelete(filter: SavedDailyLoadFilter) {
    this.deleteFilter = filter;
    this.showDeleteDialog = true;
  }

  async onDeleteFilterConfirmed() {
    this.deleting = true;
    let success = true;
    if (this.deleteFilter) {
      await this.savedDailyLoadFilterResource.deleteFilter(this.deleteFilter)
        .catch((error: any) => {
          this.reportError(error);
          success = false;
        })
        .finally(() => { this.deleting = false; });
      if (success) {
        this.$emit('filterDeleted', this.deleteFilter);
        this.showSuccess('Custom filter deleted successfully.');
      }
    }
    this.resetDialog();
    this.showDeleteDialog = false;
  }

  resetDialog() {
    this.selectedFilter = null;
    this.deleteFilter = null;
  }

  reportError = (error: any) => {
    this.showError(error);
  }

  showError(message: string) {
    const al = new Alert(message, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  showSuccess(message: string) {
    const al = new Alert(message, NoticeClass.SUCCESS);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
